import { render } from "./FormFull.vue?vue&type=template&id=4d97795c&ts=true"
import script from "./FormFull.vue?vue&type=script&lang=ts"
export * from "./FormFull.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__